<template>
	<el-table-column fixed :index="callbackIndex" type="index" width="50" label="行号">
	 
	</el-table-column>
</template>

<script>
	export default {
			      
	  data() {
	    return {
				 }
	  },
			
	  methods: {
				callbackIndex(i){
				
				 return (i+1)+this.$store.state.list.pageIndex*this.$store.state.list.pageSize
				},
			},
			
	}
</script>

<style>
</style>
